import { render, staticRenderFns } from "./form-sales-land.vue?vue&type=template&id=3b2c5305&scoped=true"
import script from "./form-sales-land.vue?vue&type=script&lang=js"
export * from "./form-sales-land.vue?vue&type=script&lang=js"
import style0 from "./form-sales-land.vue?vue&type=style&index=0&id=3b2c5305&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b2c5305",
  null
  
)

export default component.exports